import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'ngc-verify-password',
    templateUrl: './verify-password.component.html',
    styleUrls: ['./verify-password.component.scss']
})
export class VerifyPasswordComponent implements OnInit {

    @Input() formGroup: UntypedFormGroup;
    @Input() isSpinnerActive: boolean;

    @Output() cancel = new EventEmitter<void>();
    @Output() verifyPassword = new EventEmitter<void>();

    hidePassword = true;

    constructor() { }

    ngOnInit(): void {
    }

    onVerifyPassword(): void {
        this.verifyPassword.emit();
    }

    onCancel(): void {
        this.cancel.emit();
    }
}
